
import { defineComponent } from "vue";
import router from "@/router";

export default defineComponent({
  props: ["title", "redirectTo", "itemsCount"],
  setup() {
    return { router };
  },
});
